exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-24825fef] .el-card__body{height:100%}.title[data-v-24825fef]{color:var(--textColor);position:relative}.title[data-v-24825fef]:before{position:absolute;content:\"\";width:2px;height:70%;left:-8px;top:4px;background-color:var(--systemColor)}.detail-height[data-v-24825fef]{height:calc(100% - 52px)}", ""]);

// exports
